import { DESKTOP_MEDIA_QUERY, FINE_POINTER_MEDIA_QUERY } from "./constants";

export const supportsFinePointer = (win) =>
  win.matchMedia(FINE_POINTER_MEDIA_QUERY).matches;

export const isDesktopViewport = (win) =>
  win.matchMedia(DESKTOP_MEDIA_QUERY).matches;
